import { FC, memo, useCallback, Fragment } from 'react'
import { useTranslation } from '@crew/modules/i18n'
import { Menu, Transition } from '@headlessui/react'
import { CrewButton } from 'components/elements/crewButton/crewButton'
import MoreHoriz from '~icons/material-symbols/more-horiz'
import classNames from 'classnames'

export const FavoriteProjectMenuActionType = {
  activityOrder: 'activityOrder',
  nameOrder: 'nameOrder',
} as const
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type FavoriteProjectMenuActionType =
  (typeof FavoriteProjectMenuActionType)[keyof typeof FavoriteProjectMenuActionType]

export type FavoriteProjectContextMenuProps = {
  onMenuItemClick?: (action: FavoriteProjectMenuActionType) => void
}

export const FavoriteProjectContextMenu: FC<FavoriteProjectContextMenuProps> =
  memo((props) => {
    const { t } = useTranslation()

    // アクティビティ順クリック時の処理
    const handleMenuItemActivityOrderClick = useCallback(() => {
      props.onMenuItemClick?.(FavoriteProjectMenuActionType.activityOrder)
    }, [props])

    // 名前順クリック時の処理
    const handleMenuItemNameOrderClick = useCallback(() => {
      props.onMenuItemClick?.(FavoriteProjectMenuActionType.nameOrder)
    }, [props])

    return (
      <Menu as="div" className="relative inline-block text-left">
        {({ open }) => (
          <>
            <div>
              <Menu.Button
                className="flex items-center rounded-md"
                onClick={(e) => e.stopPropagation()} // アコーディオンの開閉を防ぐ
              >
                <CrewButton
                  icon={<MoreHoriz width={20} height={20} />}
                  type="normal"
                  stylingMode="text"
                  className="hover:bg-transparent focus:bg-transparent"
                  size="sm"
                />
              </Menu.Button>
            </div>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items
                static
                className="absolute font-normal right-0 z-10 w-36 origin-top-right rounded-md crew-bg-default crew-text-default shadow-lg ring-1 ring-crew-gray-200 dark:ring-crew-gray-700 focus:outline-none"
              >
                <div className="py-1">
                  <Menu.Item>
                    {({ active }) => (
                      <span
                        className={classNames(
                          { 'crew-bg-gray-2': active },
                          'block px-4 py-2 text-sm cursor-pointer'
                        )}
                        onClick={handleMenuItemActivityOrderClick}
                      >
                        {t('label.activityOrder')}
                      </span>
                    )}
                  </Menu.Item>
                  <Menu.Item>
                    {({ active }) => (
                      <span
                        className={classNames(
                          { 'crew-bg-gray-2': active },
                          'block px-4 py-2 text-sm cursor-pointer'
                        )}
                        onClick={handleMenuItemNameOrderClick}
                      >
                        {t('label.nameOrder')}
                      </span>
                    )}
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </>
        )}
      </Menu>
    )
  })
